import { OutstandingAgreementType } from '__generated__/GQL';
import getIsAgreementCompleted from 'common/bento/modules/Agreement/libs/getIsAgreementCompleted';

import { State } from '../../machine';
import model from '../../machine/model';
import locales from './locales';
import {
  GetVerificationStep,
  VerificationStatus,
  VerificationStepCategory,
} from './types';

const getAgreementsStep: GetVerificationStep = ({ verificationData }) => {
  const isAgreementCompleted = getIsAgreementCompleted({
    agreementType: OutstandingAgreementType.Cgu,
    outstandingAgreements: verificationData.viewer.outstandingAgreements,
  });

  const status = isAgreementCompleted
    ? VerificationStatus.Completed
    : VerificationStatus.ToDo;

  return {
    errors: [],
    id: State.AGREEMENT,
    metadata: {
      category: VerificationStepCategory.ShineOffer,
      description: locales.agreement.description,
      event: model.events.GO_AGREEMENT(),
      iconName: 'edit-file',
      label: locales.agreement.label,
    },
    status,
  };
};

export default getAgreementsStep;
